/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";

function checkDNSTarget(domainName, targetValue) {
    return callWSFunction("dns.checkDNSTarget", {
        domainName: domainName,
        targetValue: targetValue
    })


}


const Domains = function (domainId) {
    async function create(domainName, targetIndexKey) {
        return callWSFunction("domains.create", {
            domainId: domainId,
            domainName: domainName,
            targetIndexKey: targetIndexKey,
        })
    }


    async function getInfo() {

    }

    async function find(domainName) {
        return callWSFunction("domains.find", {
            domainId: "domainId",
            domainName: domainName,
        })
    }

    async function setTarget( targetIndexKey) {
        return callWSFunction("domains.setTarget", {
            domainId: domainId,
            targetIndexKey: targetIndexKey,
        })
    }

    async function doesExist() {

    }

    async function checkDNSTarget() {

    }


    async function update(values) {

    }


    async function verify() {


    }


    async function check() {

    }

    async function remove() {
        return callWSFunction("domains.remove", {
            domainId: domainId,
        })
    }


    return {create, verify, check, getInfo, find, setTarget, remove}
}

export default Domains;
export {checkDNSTarget}